import { Controller } from "@hotwired/stimulus"
import type { TurboSubmitEndEvent } from "@hotwired/turbo"

export default class ShowController extends Controller {
  declare nameDisplayTarget: HTMLElement
  declare hasDescriptionDisplayTarget: boolean
  declare descriptionDisplayTarget: HTMLElement
  declare editFormTarget: HTMLFormElement
  declare nameInputTarget: HTMLInputElement
  declare descriptionInputTarget: HTMLTextAreaElement
  declare actionButtonsTarget: HTMLElement
  declare saveButtonsTarget: HTMLElement

  static targets = [
    "nameDisplay",
    "descriptionDisplay",
    "editForm",
    "nameInput",
    "descriptionInput",
    "actionButtons",
    "saveButtons"
  ]

  connect() {
    this.editFormTarget.addEventListener('turbo:submit-end', this.handleSubmitEnd.bind(this))
  }

  disconnect() {
    this.editFormTarget.removeEventListener('turbo:submit-end', this.handleSubmitEnd.bind(this))
  }

  enableEdit(event: Event) {
    event.preventDefault()
    this.showEditForm()
    this.nameInputTarget.focus()
    this.nameInputTarget.select()
  }

  handleKeydown(event: KeyboardEvent) {
    if (event.key === "Enter" && event.target === this.nameInputTarget) {
      event.preventDefault()
      this.saveEdit()
    } else if (event.key === "Escape") {
      event.preventDefault()
      this.cancelEdit()
    }
  }

  saveEdit() {
    this.editFormTarget.requestSubmit()
  }

  cancelEdit() {
    this.editFormTarget.classList.add("d-none")
    this.nameDisplayTarget.classList.remove("d-none")
    this.actionButtonsTarget.classList.remove("d-none")
    this.saveButtonsTarget.classList.add("d-none")
  }

  private handleSubmitEnd(event: TurboSubmitEndEvent) {
    if (event.detail.success) {
      this.cancelEdit()
    }
  }

  private showEditForm() {
    this.nameInputTarget.value = this.nameDisplayTarget.textContent?.trim() || ""

    // Handle optional description target
    if (this.hasDescriptionDisplayTarget) {
      this.descriptionInputTarget.value = this.descriptionDisplayTarget.textContent?.trim() || ""
    } else {
      this.descriptionInputTarget.value = ""
    }

    this.nameDisplayTarget.classList.add("d-none")
    this.editFormTarget.classList.remove("d-none")
    this.actionButtonsTarget.classList.add("d-none")
    this.saveButtonsTarget.classList.remove("d-none")
  }
}
